import React from "react";
import { useStore } from "../../../../stores/store";

const Line = () => {
  const formElementStyle = "flex items-center my-2";
  const labelElementStyle = "text-md mr-3 w-1/2 flex-1 text-right";
  const inputElementStyle =
    "border border-gray-300 rounded-md p-0.5 w-1/2 text-md";
  const {
    markupLineStyle,
    setMarkupLineStyle,
    markupLineWidth,
    setMarkupLineWidth,
    markupLineColor,
    setMarkupLineColor,
  } = useStore();
  return (
    <>
      <div className={formElementStyle}>
        <label className={labelElementStyle}>Style:</label>
        <select
          className={inputElementStyle}
          value={markupLineStyle}
          onChange={(e) => setMarkupLineStyle(e.target.value)}
        >
          <option value="dash">dash</option>
          <option value="dash dot">dash dot</option>
          <option value="dash dot dot">dash dot dot</option>
          <option value="dot">dot</option>
          <option value="short dash dot dot">short dash dot dot</option>
          <option value="solid">solid</option>
        </select>
      </div>
      <div className={formElementStyle}>
        <label className={labelElementStyle}>Width:</label>
        <input
          type="number"
          className={inputElementStyle}
          value={markupLineWidth}
          onChange={(e) => setMarkupLineWidth(Number(e.target.value))}
        />
      </div>
      <div className={formElementStyle}>
        <label className={labelElementStyle}>Color:</label>
        <input
          value={markupLineColor}
          onChange={(e) => setMarkupLineColor(e.target.value)}
          className={inputElementStyle}
          type="color"
        />
      </div>
    </>
  );
};

export default Line;
